import { Trans } from "@lingui/macro";
import { UiBox, UiButton } from "@smp/ui";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";

import { useStyles } from "./controls_auth.css";

export const ControlsAuth = () => {
  const classes = useStyles();
  const next =
    (typeof window !== "undefined" &&
      `${window.location.pathname}${window.location.search || ""}`) ||
    undefined;

  return (
    <UiBox display="flex" className={classes.wrapper}>
      <UiButton
        variant="outlined"
        gutterRight
        className={classes.button_outlined}
        component={HelperAdapterLink}
        to={{
          pathname: "/auth/signin",
          state: { next },
        }}
      >
        <Trans>Sign in</Trans>
      </UiButton>
      <UiButton
        variant="outlined"
        className={classes.button_outlined}
        component={HelperAdapterLink}
        to={{
          pathname: "/auth/signup",
          state: { next },
        }}
      >
        <Trans>Sign up</Trans>
      </UiButton>
    </UiBox>
  );
};
